import { render, staticRenderFns } from "./projectBoard_black.vue?vue&type=template&id=70889e49&scoped=true"
import script from "./projectBoard_black.vue?vue&type=script&lang=js"
export * from "./projectBoard_black.vue?vue&type=script&lang=js"
import style0 from "./projectBoard_black.vue?vue&type=style&index=0&id=70889e49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70889e49",
  null
  
)

export default component.exports